import React from 'react';
import { FOCUS_RING } from './focusRing';
import type { FontSize } from './Typography/Text';

export interface LinkProps {
    href: string;
    target?: '_blank' | '_self' | '_parent' | '_top';
    rel?: string;
    children: React.ReactNode;
    className?: string;
    color?: 'default' | 'dimmed';
    size?: FontSize;
    underline?: boolean;
}

const getFontSizeClass = (size?: FontSize): string => {
    if (!size) return '';
    switch (size) {
        case 'xsmall':
            return 'text-[length:var(--malachite-font-size-xsmall)]';
        case 'small':
            return 'text-[length:var(--malachite-font-size-small)]';
        case 'medium':
            return 'text-[length:var(--malachite-font-size-medium)]';
        case 'large':
            return 'text-[length:var(--malachite-font-size-large)]';
        case 'xlarge':
            return 'text-[length:var(--malachite-font-size-xlarge)]';
        case 'xxlarge':
            return 'text-[length:var(--malachite-font-size-xxlarge)]';
        default:
            return '';
    }
};

export const Link: React.FC<LinkProps> = ({
    children,
    href,
    target = '_blank',
    rel = 'noopener noreferrer',
    className = '',
    color = 'default',
    size,
    underline = true,
}) => {
    const colorClasses =
        color === 'dimmed'
            ? 'text-[var(--malachite-text-dimmed)] hover:text-[var(--malachite-text-primary)]'
            : 'text-[var(--malachite-text-link-foreground)] hover:text-[var(--malachite-text-link-foreground-hover)]';

    const fontSizeClasses = getFontSizeClass(size);

    return (
        <a
            href={href}
            target={target}
            rel={rel}
            className={`${underline ? 'underline' : 'no-underline'} rounded-xs cursor-pointer transition-colors duration-200 ease-in-out ${FOCUS_RING} ${colorClasses} ${fontSizeClasses} ${className}`}
        >
            {children}
        </a>
    );
};

export default Link;

